/**
 * @prettier
 */

import React, { Fragment } from 'react';
import styles from './styles.module.less';

const TextElement = ({ element }) => {
  if (!element || !element.body) {
    return null;
  }

  const lines = element.body.split('\n');

  const body = lines.map((s, i) => (
    <Fragment key={i}>
      {s}
      {i !== lines.length - 1 && <br />}
    </Fragment>
  ));

  const characterSpacing = element.font.character_spacing || element.character_spacing;
  const letterSpacing = characterSpacing ? characterSpacing * 0.001 : 0;

  const style = {
    zIndex: element.layer,
    left: `${element.x}pt`,
    top: `${element.y}pt`,
    width: `${element.width}pt`,
    height: `${element.height}pt`,
    color: `#${element.font.font_color || element.font_color || 'black'}`,
    fontFamily: `'${element.font.font_family || element.font_family}'`,
    fontSize: `${element.font.font_size || element.font_size}pt`,
    fontStyle: element.font.font_style || element.font_style,
    fontWeight: `${element.font.font_weight || element.font_weight}`,
    textAlign: (
      element.font.horizontal_alignment ||
      element.horizontal_alignment ||
      'LEFT'
    ).toLowerCase(),
    verticalAlign: (element.font.vertical_alignment || 'TOP').toLowerCase(),
    letterSpacing: `${letterSpacing}em`,
    lineHeight: `${element.font.line_height || element.line_height}pt`,
  };

  return (
    <div className={styles.textLayer} style={style}>
      {body}
    </div>
  );
};

export default TextElement;
